// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.K8PBRGKIUMjj1zsiFX3C {
  border: none;
  border-radius: 10px;
  color: white;
  font-family: 'Archivo'; 
  font-size: 16px;
  letter-spacing: 0.3px;
  cursor: pointer;
  max-width: 250px;
}

._tFj3PV1gtugcCCpAjVV {
  background-color: #009688;
}

._tFj3PV1gtugcCCpAjVV:hover {
  background-color: #028578;
}

.Po_DijAC5FfFMqBrVd_K {
  background-color: white;
  color: black;
  border: 1px solid black;
}

.Po_DijAC5FfFMqBrVd_K:hover {
  opacity: 0.89;
}

.F1F5Lm8YKSRW54gzkiM3 {
  padding: 8px 20px;
  font-size: 15px;
}

.mubaErQkG0CfQd4njNri {
  padding: 12px 24px;
  font-size: 16px;
}

.GHZzyHmD4FuQuObv6gfp {
  display: flex;
  align-items: center;
  justify-content: center;
}

.K8PBRGKIUMjj1zsiFX3C svg {
  margin-right: 6px;
}
`, "",{"version":3,"sources":["webpack://./client/src/components/UI/Button/Button.module.css"],"names":[],"mappings":";AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":["\n.button {\n  border: none;\n  border-radius: 10px;\n  color: white;\n  font-family: 'Archivo'; \n  font-size: 16px;\n  letter-spacing: 0.3px;\n  cursor: pointer;\n  max-width: 250px;\n}\n\n.primary {\n  background-color: #009688;\n}\n\n.primary:hover {\n  background-color: #028578;\n}\n\n.secondary {\n  background-color: white;\n  color: black;\n  border: 1px solid black;\n}\n\n.secondary:hover {\n  opacity: 0.89;\n}\n\n.medium {\n  padding: 8px 20px;\n  font-size: 15px;\n}\n\n.large {\n  padding: 12px 24px;\n  font-size: 16px;\n}\n\n.buttonInner {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.button svg {\n  margin-right: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `K8PBRGKIUMjj1zsiFX3C`,
	"primary": `_tFj3PV1gtugcCCpAjVV`,
	"secondary": `Po_DijAC5FfFMqBrVd_K`,
	"medium": `F1F5Lm8YKSRW54gzkiM3`,
	"large": `mubaErQkG0CfQd4njNri`,
	"buttonInner": `GHZzyHmD4FuQuObv6gfp`
};
export default ___CSS_LOADER_EXPORT___;
